import { Link } from "react-router-dom";

export default function GetInvolved() {
  const involvementWays = [
    { title: "Volunteer", text: "Join our team of volunteers and make a direct impact in our programs." },
    { title: "Partner with Us", text: "Collaborate with us as a corporate or organizational partner." },
    { title: "Advocate", text: "Spread awareness and support our mission through advocacy." },
  ];

  return (
    <section className="py-20 px-6 max-w-4xl mx-auto">
      <h2 className="text-4xl font-bold mb-12 text-center text-[#2D033B]">
        Get Involved
      </h2>

      <div className="grid md:grid-cols-3 gap-8 mb-12">
        {involvementWays.map((item) => (
          <div
            key={item.title}
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition border border-[#E5D9F2]"
          >
            <h3 className="text-xl font-semibold mb-2 text-[#6A0DAD]">
              {item.title}
            </h3>
            <p className="text-[#5A3D73]">{item.text}</p>
          </div>
        ))}
      </div>

      <div className="text-center">
        <Link
          to="/donate"
          className="bg-[#6A0DAD] text-white px-8 py-3 rounded-md text-lg font-semibold transition hover:bg-[#5F0F99]"
        >
          Support Our Mission
        </Link>
      </div>
    </section>
  );
}
